<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} khám dịch</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} khám dịch</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} khám dịch</span>
        <div class="card-header-actions"></div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import KhamDichModel from "./KhamDichModel";
import KhamDichApi from "../../../moduleApi/KhamDichApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "KhamDich",
        dataDefault: {
        },
        dataForm: {},
        validForm: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            MethodService.stopLadda();
          return false;
          }

          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await KhamDichApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await KhamDichApi.findById(id);
      this.mData.dataForm = res.result;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    async fn_initDataDefault() {
    },

  },
  created: function() {
    // this.fn_initDataDefault();
    // if (
    //   this.$router.currentRoute.name ==
    //   "Admin-" + this.mData.moduleName + "-update"
    // ) {
    //   this.mData.viewMode = "update";
    // }
    // if (
    //   this.$router.currentRoute.name ==
    //   "Admin-" + this.mData.moduleName + "-detail"
    // ) {
    //   this.mData.viewMode = "detail";
    // }
    // if (this.$router.currentRoute.params.id) {
    //   this.fn_getDataById(this.$router.currentRoute.params.id);
    // }
  },
  mounted: function() {}
};
</script>